/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-05-12 19:53:03
 * @FilePath: \crane-safety-manager\src\slices\statistics\reducer.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createSlice } from '@reduxjs/toolkit';

import * as thunk from './thunk';

export const initialState = {
    alarmType:{},
    alarmsCount: {},
    alarmsTypeCountProject: [],
    alarmsTypeCountSite: [],
    alarmsTypeCountVehicle: [],
    alarmsDailyCountProject: [],
    onlineTime:{},
    faultyStarts:{},
    alarm: {},
    project: {},
    user: {},
    dashboard: {
        vehicleDistributionMapData: [],
        vehicles: []
    },
    loading: true
};

const StatisticSlice = createSlice({
    name: 'Statistics',
    initialState,
    reducers: {},
    extraReducers: builder => {
        /**
         * <--------------------------- alarm --------------------------->
         */
        builder.addCase(thunk.alarm.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarm.fulfilled, (state, action) => {
            state.loading = false;
            state.alarm = action.payload;
        });
        builder.addCase(thunk.alarm.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- user --------------------------->
         */
        builder.addCase(thunk.user.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.user.fulfilled, (state, action) => {
            state.user = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.user.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- project --------------------------->
         */
        builder.addCase(thunk.project.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.project.fulfilled, (state, action) => {
            state.project = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.project.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmTypes --------------------------->
         */
        builder.addCase(thunk.alarmType.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmType.fulfilled, (state, action) => {
            state.alarmType = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmType.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmsCount --------------------------->
         */
        builder.addCase(thunk.alarmsCount.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmsCount.fulfilled, (state, action) => {
            state.alarmsCount = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmsCount.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        builder.addCase(thunk.resetAlarm.fulfilled, (state, action) => {
        });
        builder.addCase(thunk.resetAlarm.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- faultyStarts --------------------------->
         */
        builder.addCase(thunk.faultyStarts.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.faultyStarts.fulfilled, (state, action) => {
            state.faultyStarts = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.faultyStarts.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- onlineTime --------------------------->
         */
        builder.addCase(thunk.onlineTime.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.onlineTime.fulfilled, (state, action) => {
            state.onlineTime = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.onlineTime.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
        
        builder.addCase(thunk.reset.fulfilled, (state, action) => {
        });
        builder.addCase(thunk.reset.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- dashboard --------------------------->
         */
        builder.addCase(thunk.dashboard.fulfilled, (state, action) => {
            const data = action.payload || {};
            state.dashboard.vehicleDistributionMapData = data.vehicleDistributionMapData || [];
            state.dashboard.vehicles = data.vehicles || [];
            // state.loading = true;
        });
        builder.addCase(thunk.dashboard.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmsTypeCountProject --------------------------->
         */
        builder.addCase(thunk.alarmsTypeCountProject.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmsTypeCountProject.fulfilled, (state, action) => {
            state.alarmsTypeCountProject = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmsTypeCountProject.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmsTypeCountSite --------------------------->
         */
        builder.addCase(thunk.alarmsTypeCountSite.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmsTypeCountSite.fulfilled, (state, action) => {
            state.alarmsTypeCountSite = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmsTypeCountSite.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmsTypeCountProject --------------------------->
         */
        builder.addCase(thunk.alarmsTypeCountVehicle.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmsTypeCountVehicle.fulfilled, (state, action) => {
            state.alarmsTypeCountVehicle = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmsTypeCountVehicle.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        /**
         * <--------------------------- alarmsDailyCountProject --------------------------->
         */
        builder.addCase(thunk.alarmsDailyCountProject.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(thunk.alarmsDailyCountProject.fulfilled, (state, action) => {
            state.alarmsDailyCountProject = action.payload;
            state.loading = false;
        });
        builder.addCase(thunk.alarmsDailyCountProject.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

    }
});

export default StatisticSlice.reducer;
